import React, {useEffect, useState} from "react";
import {
  CardContent,
  Typography,
  ListItem,
  Box,
  ListItemText,
  LinearProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAppContext } from "../../context/AppContext";
import CONFIG from "../../utils/config";


const FundingStatusCard = () => {
  const {state, actions} = useAppContext();

  const fundingScore = state.fundingScore;
  const clientName = state.clientName;
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [infoContent, setInfoContent] = useState("assumptions");

  useEffect(() => {
    const current_year = new Date().getFullYear();
    function presentValue(rate, nper, pmt, fv, type = 1) {
      if (rate === 0) {
        return -((pmt * nper) + fv);
      } else {
        return -(pmt * ((1 - Math.pow(1 + rate, -nper)) / rate) + fv / Math.pow(1 + rate, nper));
      }
    }
    // const discount_rate = state.riskProfile === "Balanced" ? 0.107 : state.riskProfile === "Aggressive" ? 0.12 : CONFIG.DEFAULT_POST_RETIREMENT_RETURN;
    const discount_rate = CONFIG.EXPECTED_ROR[state.riskProfile]
    const totalPresentValueGoals = state.goals.reduce((sum, goal) => {

      const years_to_goal = Math.max(0, goal.targetYear - current_year - 3);

      let short_term_goal = 3;
      if (goal.targetYear - current_year < 3) {
        short_term_goal = goal.targetYear - current_year;
      }

      const intermediate_PV = presentValue(discount_rate, years_to_goal, 0, Number(goal.FV_goal), 0);
      const PresentValue_goals = presentValue(CONFIG.DEFAULT_DEBT_RETURN, short_term_goal, 0, intermediate_PV, 1);
      return sum + PresentValue_goals;
    }, 0);


    const totalPresentValueEducation = state.kidsEducation.reduce((sum, kid, index) => {
      let totalKidPV = 0;
        const yearsToUG = Math.max(0, CONFIG.DEFAULT_ug_AGE - kid.Age - 3);
        let short_term_goal_ug = 3;
        if (yearsToUG < 3) {
          short_term_goal_ug = yearsToUG;
        }
        const intermediate_ugPV = presentValue(discount_rate, yearsToUG, 0, kid.ug_fees_FV, 0);
        const ugPV = presentValue(CONFIG.DEFAULT_DEBT_RETURN,short_term_goal_ug, 0, intermediate_ugPV, 1);
        totalKidPV += ugPV;

      // PG Calculation
        const yearsToPG = Math.max(0, CONFIG.DEFAULT_pg_AGE - kid.Age - 3);
        let short_term_goal_pg = 3
        if (yearsToPG < 3) {
          short_term_goal_pg = yearsToPG;
        }
        const intermediate_pgPV = presentValue(discount_rate, yearsToPG, 0, kid.pg_fees_FV, 0);
        const pgPV = presentValue(CONFIG.DEFAULT_DEBT_RETURN,short_term_goal_pg, 0, intermediate_pgPV, 1);
        totalKidPV += pgPV;
      return sum + totalKidPV;
    }, 0);
    // console.log("------------corpus required---------->",state.corpusRequired)
    // console.log("state.yearsForRetirement",state.yearsForRetirement, "totalPresentValueGoals",totalPresentValueGoals, "state.emergencyFunds", state.emergencyFunds, "totalPresentValueEducation",totalPresentValueEducation)
    const amountRequiredToday = (state.corpusRequired / Math.pow(1 + discount_rate, state.yearsForRetirement)) + totalPresentValueGoals + totalPresentValueEducation + state.emergencyFunds;
    // console.log("net worth------>",state.netWorth)
    actions.updateFormData('amountRequiredToday', amountRequiredToday);
    const fundingRatio = state.netWorth / amountRequiredToday;
    // console.log("amountRequiredToday",amountRequiredToday)
    const fundingScore = Math.min(100, Math.round(fundingRatio * 100));
    // console.log(fundingScore)
    if (state.fundingScore !== fundingScore) {
      actions.updateFormData('fundingScore', fundingScore);
    }

  // },[state.corpusRequired, state.goals, state.netWorth, state.riskProfile, state.yearsForRetirement, actions])
  },[])

  const handleInfoDialogOpen = () => {
    setInfoDialogOpen(true);
};

const handleInfoDialogClose = () => {
    setInfoDialogOpen(false);
};


  const handleChange = () => {
    // onChange(6)
  }

  return (
    <Box>
    <CardContent > 
        <ListItem>
              <ListItemText  
                primary={
                  <Box sx={{ mt: 1 }}>
                    <Box>
                      <Typography variant="h4" align="center" sx={{fontWeight:"bold"}} color={fundingScore < 30 ? "error" : 
                        fundingScore < 70 ? "warning" : "success"}>{state.fundingScore}% 
                        <Button
                        variant="text"
                        color="primary"
                        startIcon={<InfoIcon />}
                        // endIcon={<KeyboardArrowDownIcon />}
                        onClick={() => {
                                    setInfoContent("assumptions")
                                    handleInfoDialogOpen()}}
                        sx={{ mr: -4, textTransform: 'none', fontSize: '0.875rem' }}
                        >
                      </Button></Typography>
                      <Typography variant="h6" align="center" sx={{pl:1}}>of your goals are secured</Typography>
                    </Box>
                    <LinearProgress 
                      variant="determinate" 
                      value={fundingScore} 
                      align="center"
                      color={
                        fundingScore < 30 ? "error" : 
                        fundingScore < 70 ? "warning" : "success"
                      }
                      sx={{ pl: -2, height: 15, borderRadius: 5 }}
                    />
                  </Box>
                }
              />
            </ListItem>


            { fundingScore < 40 ? 
            (<><Typography variant="body1" fontWeight="bold" sx={{mt:2}}>
            That’s a start {clientName.split(" ")[0]}, but there’s still a long way to go. <span style={{ fontWeight: "normal" }}>Plan and persistence will take you all the way.</span>
            </Typography>
            <br></br>
            <Typography variant="body1" sx={{mb:2}}>
            Consistent saving and systematic investing build momentum - However it’s your <span style={{ fontWeight: "bold" }}> Asset Allocation</span>, tailored to your goals and risk, that truly propels you toward the finish line.
            </Typography></>) :
            fundingScore < 60 ?
            <>
            <Typography variant="body1" fontWeight="bold" sx={{mt:2}}>
            You are about halfway there, {clientName.split(" ")[0]}. <span style={{ fontWeight: "normal" }}>Plan and persistence will take you all the way.</span>
            </Typography>
            <br></br>
            <Typography variant="body1" sx={{mb:2}}>
            Consistent saving and systematic investing build momentum - However it’s your <span style={{ fontWeight: "bold" }}> Asset Allocation</span>, tailored to your goals and risk, that truly propels you toward the finish line.
            </Typography>
            </> :
            fundingScore < 80 ?
            (<><Typography variant="body1" fontWeight="bold" sx={{mt:2}}>
            That’s commendable progress, {clientName.split(" ")[0]}. <span style={{ fontWeight: "normal" }}>Plan and persistence will take you all the way.</span>
            </Typography>
            <br></br>
            <Typography variant="body1" sx={{mb:2}}>
            Consistent saving and systematic investing build momentum - but it’s your <span style={{ fontWeight: "bold" }}> Asset Allocation</span>, tailored to your goals and risk, that truly propels you toward the finish line.
            </Typography>
            </>) :
            fundingScore < 100 ?
            (<><Typography variant="body1" fontWeight="bold" sx={{mt:2}}>
            You are almost there, {clientName.split(" ")[0]}. <span style={{ fontWeight: "normal" }}>!You’ve worked hard to get this far, plan and persistence will take you all the way.</span>
            </Typography>
            <br></br>
            <Typography variant="body1" sx={{mb:2}}>
            Consistent saving and systematic investing build momentum - However it’s your <span style={{ fontWeight: "bold" }}> Asset Allocation</span>, tailored to your goals and risk, that truly propels you toward the finish line.
            </Typography>
            </>)
            :
            (<><Typography variant="body1" fontWeight="bold" sx={{mt:2}}>
            Congratulations, {clientName.split(" ")[0]}!! You’ve done it. You are Financially Independent.
            </Typography>
            <br></br>
            <Typography variant="body1" sx={{mb:2}}>
            But it’s not over till it’s truly over. Let’s ensure that your <span style={{ fontWeight: "bold" }}>Asset Allocation</span> stays aligned for stability, calibrated risk, balance growth, and - most important of all - peace of mind.
            </Typography>
            </>)
            }
            
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        // startIcon={<InfoIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={() =>{
                                  setInfoContent("assetAllocation")
                                  handleInfoDialogOpen()
                                  }}
                        sx={{ textTransform: 'none', fontSize: '0.875rem', my:3}}
                    >
                        What is Asset Allocation?
                    </Button>
                </Box>

            <Button
                variant="contained"
                color="success"
                fullWidth
                size="large"
                onClick={() => {
                  handleChange();
                  actions.nextStepGoal()
                }}
                // endIcon={<ArrowForwardIcon />}
                sx={{
                    borderRadius: 1,
                    py: 1.5,
                    textTransform: 'none',
                    fontWeight: 'bold'
                    
                }}
            >
                WHAT TO DO NEXT?
            </Button>
      </CardContent>

      <Dialog
        open={infoDialogOpen}
        onClose={handleInfoDialogClose}
        aria-labelledby="info-dialog-title"
        maxWidth="sm"
        fullWidth
        >
        <DialogContent>
        {infoContent === "assumptions" ?<>
        <Typography variant="body2" color="textSecondary" paragraph>
        Based on your inputs and following assumptions:
        <br></br>
        Life Expetancy: {CONFIG.DEFAULT_LIFE_EXPECTANCY}
        <br></br>
        Annual Inflation: {CONFIG.DEFAULT_INFLATION_RATE_STRING} 
        <br></br>
        Asset Allocation: {state.riskProfile} 
        <br></br>
        Expected net Rate of Return: {CONFIG.EXPECTED_ROR_STRING[state.riskProfile]}
        <br></br>
        </Typography></>:

        <>
        <Typography>
        It's not your stock selection or your market timing — but your Asset Allocation - that drives most of your returns and risk.
        <br></br>
        <br></br>
        Asset Allocation means diversifying your investments across various asset classes such as Indian equities, global equities, gold, debt and income assets — based on your goals, time horizon, and risk tolerance.
        <br></br>
        <br></br>
        It’s the single most important decision that determines how your wealth grows and how much risk you take for it.
        </Typography>
        </>}

        </DialogContent>
        <DialogActions>
        <Button onClick={handleInfoDialogClose} variant="contained">
            Got it
        </Button>
        </DialogActions>
      </Dialog>
</Box>
  );
};

export default FundingStatusCard;
